export default __webpack_public_path__ + "static/media/default.4af8a39e.svg";